enum ThemeStyleguideColorsCategory {
  PRIMARY_COMMUNITY = 'primaryCommunity',
  ADDITIONAL_COLORS = 'additionalColors',
  CONTENT_TYPE_ICONS = 'contentTypeIcons',
  ALERT_MESSAGES = 'alertMessages'
}

export default ThemeStyleguideColorsCategory;
